<!-- 答题卡 -->
<template>
  <el-drawer
    title=""
    :custom-class="
      isFullScreen
        ? 'is-full-screen answer-sheet-drawer'
        : 'answer-sheet-drawer'
    "
    :visible.sync="drawer"
    direction="btt"
    :before-close="handleClose"
  >
    <div class="answer-sheet-cont">
      <div class="title-wrap" :style="handlePageStyle">
        <p class="title">
          答题卡
          <button class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </button>
        </p>
      </div>

      <ul class="number-wrap">
        <li
          @click="handleNumberClick(item)"
          class="number-item"
          v-for="item in questionList"
          :key="item.question_id"
          :class="{
            'is-answer': item.is_answer,
            'is-right': isCorrected && item.is_answer && item.is_right,
            'is-wrong': isCorrected && item.is_answer && !item.is_right,
            'is-mark': item.is_markers === 1,
          }"
        >
          {{ item.question_num }}
        </li>
      </ul>
      <button v-if="canSubmit" @click="submitAnswer" class="submit-btn">
        提交
      </button>
    </div>
  </el-drawer>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapState, mapGetters, mapActions } from "vuex";
import { isHXApp } from "@saas/components";
export default {
  props: {
    deviceSpace: {
      type: Object,
      default: () => {
        return {
          top: 0,
          bottom: 0,
        };
      },
    },
  },
  data() {
    return {
      drawer: false,
      isFullScreen: false,
    };
  },
  mounted() {
    // 处理进入答题卡界面
    EventBus.$off(`show-answer-sheet-page`);
    EventBus.$on(`show-answer-sheet-page`, () => this.openDrawer(true));
  },
  methods: {
    ...mapActions("defaultHomework", ["submitAnswer"]),
    handleClose() {
      this.drawer = false;
    },
    openDrawer(isFullScreen = false) {
      this.isFullScreen = isFullScreen;
      this.drawer = true;
    },
    // 跳转到指定题目
    handleNumberClick(item) {
      let { question_id, question_pid, sub_index, question_num } = item;
      let pidIndex = this.questionIndexArr[question_num - 1];
      let time = 250;
      if (this.questionInfo.pidIndex === pidIndex) {
        time = 0;
      } else {
        this?.$parent?.$refs?.questionList?.swiper?.slideTo(pidIndex);
      }
      if (question_pid) {
        // 复合题
        setTimeout(() => {
          EventBus.$emit(`changeSubQuestion${question_pid}`, {
            id: question_id,
            subIndex: sub_index,
          });
        }, time);
      }
      this.handleClose();
    },
  },
  computed: {
    ...mapGetters("defaultHomework", [
      "canSubmit",
      "questionInfo",
      "questionIndexArr",
    ]),
    ...mapState("defaultHomework", ["questionList", "isCorrected"]),
    handlePageStyle() {
      if (this.isFullScreen && isHXApp()) {
        return {
          paddingTop: `${this.deviceSpace.top}px`,
        };
      } else {
        return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .answer-sheet-drawer {
  background: #ffffff;
  border-radius: 0.32rem 0.32rem 0rem 0rem;
  height: auto !important;
  #el-drawer__title {
    display: none;
  }
  // 全屏
  &.is-full-screen {
    height: 100% !important;
    border-radius: 0;
  }
}
.answer-sheet-cont {
  display: flex;
  flex-direction: column;
  min-height: 6.96rem;
  max-height: calc(100vh - 2.5rem);
  .title {
    position: relative;
    font-weight: 500;
    font-size: 0.43rem;
    color: #1d2129;
    line-height: 0.59rem;
    text-align: center;
    padding: 0.43rem 0 0.3rem;
  }
  .close-btn {
    position: absolute;
    top: 0.45rem;
    right: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 0.53rem;
      font-weight: bold;
      color: #1d2129;
    }
  }
  .number-wrap {
    flex: 1;
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    padding: 0.13rem 0.19rem 0;
    overflow-y: auto;
    align-content: flex-start;
  }
  .number-item {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    background: #f2f3f5;
    font-weight: 500;
    font-size: 0.43rem;
    color: #4e5969;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    margin: 0 0.4rem 0.48rem;
    position: relative;
    &.is-answer {
      background: $homework-default-bg;
      color: $homework-default-color;
    }
    &.is-right {
      background: $homework-right-bg;
      color: $homework-right-color;
    }
    &.is-wrong {
      background: $homework-wrong-bg;
      color: $homework-wrong-color;
    }
    &.is-mark::after {
      position: absolute;
      display: block;
      content: "";
      background: url("../../../assets/images/homework/mark.png") no-repeat
        center;
      background-size: 100% 100%;
      width: 0.43rem;
      height: 0.43rem;
      top: -0.13rem;
      right: -0.13rem;
    }
  }
  .submit-btn {
    width: 9.36rem;
    background: #386bff;
    border-radius: 0.53rem;
    margin: 0.08rem auto 0.93rem;
    font-weight: 500;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 1.07rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 全屏
.is-full-screen .answer-sheet-cont {
  height: 100%;
  max-height: none;
  .close-btn {
    position: absolute;
    top: 0.29rem;
    left: 0.43rem;
    right: auto;
  }
  .title {
    padding-top: 0.24rem;
  }
  .number-wrap {
    align-items: flex-start;
    align-content: flex-start;
  }
}
</style>
